export default __webpack_public_path__ + "static/media/icon5-new.fccd370d.svg";